<script setup lang="ts">
import * as Sentry from '@sentry/vue';
import ModalImage from '~/assets/modal-outdated-browser.svg?url';

const emits = defineEmits<{
	(e: 'dismiss'): void;
}>();

onMounted(() => {
	Sentry.logger.info('[OutdatedBrowser]: show info to user');
});

const dismiss = () => {
	Sentry.logger.info('[OutdatedBrowser]: user dismissed info manually');
	emits('dismiss');
};

</script>

<template>
	<div class="h-full">
		<NuxtLayout name="blank">
			<div class="flex min-h-full flex-1 flex-col justify-center">
				<ErrorScreen
					:title="$t('modal.outdatedBrowser.title')"
					:image="ModalImage"
					:subtitle="$t('modal.outdatedBrowser.description')"
					size="xl"
				>
					<div class="flex items-center justify-center gap-2">
						<UButton
							color="neutral"
							variant="outline"
							@click="dismiss"
						>
							{{ $t('modal.outdatedBrowser.button') }}
						</UButton>
					</div>
				</ErrorScreen>
			</div>
		</NuxtLayout>
	</div>
</template>
